<template>
<body style="background-color:#D6D6D6">
    <div id="cuentos">

        <v-container>
            <!--<h1 class="pl-5 ml-4 pt-5" style="color:#942C75; font-family:Poppins; font-size:1.8vw; font-weight:500">{{title}}</h1>-->
            <!--<v-layout row wrap>
            <v-flex sm4 md4 lg3 class="pl-4 ml-4 pt-5" >
            <v-card style="background-color:#66A66E">
              <v-card-title><span class="titlecuentos" style="color:white; font-family:Poppins;  font-weight:600">CANCIONES</span></v-card-title>
            </v-card>
            </v-flex>
            <v-flex md1 class="pt-5" >
            <v-card flat style="background-color:#4eae6d">
              <img src="CANCIONES.png"  style="position:absolute;margin-left:-30px; margin-top:-8px" />
            </v-card>
            </v-flex>
            </v-layout>-->
            <ContentCanciones :canciones="canciones">
            </ContentCanciones>
            
       </v-container>
         

    </div>
    </body>
</template>


<script>
import ContentCanciones from "@/components/ContentCanciones.vue"

export default {
   
    components:{
       ContentCanciones
     },

    data(){
        return{
            title:"CANCIONES",
            canciones:[
          
          {title:"Lalabumers en acción",img:"Cancion1.png",url:"../descargas/files/canciones/1.-lalabumers en accion.mp3",namedownload:"Lalabumers_en_Accion"},
          {title:"Soy un Lalabumer",img:"Cancion2.png",url:"../descargas/files/canciones/2.-soy un lalabumer.mp3",namedownload:"Soy_un_Lalabumer"},
          {title:"Buen día Lalabumer",img:"Cancion3.png",url:"../descargas/files/canciones/3.-buen dia lalabumer.mp3",namedownload:"Buen_dia_Lalabumer"},
          {title:"Lalabumers a comer",img:"Cancion4.png",url:"../descargas/files/canciones/4.-lalabumers a comer.mp3",namedownload:"Lalabumers_a_comer"},
          {title:"Mis amigos Lalabumers",img:"Cancion5.png",url:"../descargas/files/canciones/5.-mis amigos lalabumers.mp3",namedownload:"Mis_amigos_lalabumers"},
          {title:"Me cuido como Lalabumer",img:"Cancion6.png",url:"../descargas/files/canciones/6.-me cuido como lalabumer.mp3",namedownload:"Me_cuido_como_lalabumer"},
          {title:"Mueve tus pies Lalabumer",img:"Cancion7.png",url:"../descargas/files/canciones/7.-mueve tus pies lalabumer.mp3",namedownload:"Mueve tus pies Lalabumer"},
          {title:"Lalacumple",img:"Cancion_lalacumple.png",url:"../descargas/files/canciones/8.-cumpleanios_lalabum.mp3",namedownload:"Lalacumple"},
          {title:"Nice Job",img:"Cancion_well_done.png",url:"../descargas/files/canciones/9.-nice_job.mp3",namedownload:"Nice_job"},
          {title:"Mi mami es la mejor",img:"Cancion_dia_de_las_madres.png",url:"../descargas/files/canciones/10.-mama.mp3",namedownload:"Mi_mami_es_la_mejor"}
         
          
        ]
        }
    }
}
</script>

<style >
.actividad.cuento{
    background-color:#4D93A8; 
    color: white;
    font-family: "Poppins";
    font-weight: 500;
    font-size: 1.5vw; 
    height: 60px;
  }

  @media (min-width: 1200px){
    .titlecuentos{
      font-size:1.2vw;
    }
  }
</style>


